import { parseCollectionImageMetaData } from '@/search-for-retail/collections/collections.parsers';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------
const COLLECTION_PATH = '/project/config/collections';
/**
 * RTK Query endpoints for collections.
 *
 * Endpoints sit under `/project/config/collections`.
 * Auth and tenant headers are handled by the base `ccApi`.
 *
 * @see https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting
 */
export const collectionsApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        // -----------------------------------------------------------------------
        // Queries
        // -----------------------------------------------------------------------
        getCollections: builder.query({
            query: () => COLLECTION_PATH,
            providesTags: [CC_API_TAGS.CollectionList],
        }),
        getCollectionByName: builder.query({
            query: ({ collectionName }) => `${COLLECTION_PATH}/${collectionName}`,
            providesTags: (_result, _error, { collectionName }) => [
                { type: CC_API_TAGS.Collection, id: collectionName },
            ],
        }),
        getCollectionImageMetaData: builder.query({
            query: ({ collectionName }) => `${COLLECTION_PATH}/${collectionName}/metadata`,
            transformResponse: (response) => parseCollectionImageMetaData(response),
            providesTags: (_result, _error, { collectionName }) => [
                { type: CC_API_TAGS.CollectionImageMetaData, id: collectionName },
            ],
        }),
        // -----------------------------------------------------------------------
        // Mutations
        // -----------------------------------------------------------------------
        updateCollection: builder.mutation({
            query: ({ collectionName, data }) => ({
                url: `${COLLECTION_PATH}/${collectionName}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: (_result, _error, { collectionName }) => [
                CC_API_TAGS.CollectionList,
                { type: CC_API_TAGS.Collection, id: collectionName },
            ],
        }),
    }),
});
export const { useGetCollectionsQuery, useGetCollectionByNameQuery, useGetCollectionImageMetaDataQuery, useLazyGetCollectionImageMetaDataQuery, useUpdateCollectionMutation, } = collectionsApi;
